module.exports = __webpack_public_path__ + "img/private_plot.6b024d88.svg";